const ForethoughtConstants = {
  FORETHOUGHT_SCRIPT_URL: 'https://solve-widget.forethought.ai/embed.js',
  FORETHOUGHT_SCRIPT_ID: 'forethought-widget-embed-script',
  FORETHOUGHT_API_KEY: '53ba33cc-d24f-4b17-a338-f48f5e86e76d',
  FORETHOUGHT_TOKEN_CV_UUID: '5181cd13_e352_409c_916e_29d08ddf3e84',
  FORETHOUGHT_WORKFLOW_TAGS: {
    development: 'development',
    production: 'production',
  },
  FORETHOUGHT_CONFIG: {
    'data-ft-zendesk-token': 'null',
    'hide-ft-after-zd': 'true',
    'emit-tracking-events': 'true',
  },
  FORETHOUGHT_EVENTS: {
    closed: 'forethoughtWidgetClosed',
    error: 'forethoughtWidgetError',
    loaded: 'forethoughtWidgetLoaded',
    stateChanged: 'forethoughtStateChanged',
    opened: 'forethoughtWidgetOpened',
    initializing: 'forethoughtWidgetStartedInitializing',
    handoffStarted: 'forethoughtWidgetIntegrationHandoff',
    handoffCompleted: 'forethoughtWidgetIntegrationHandoffCompleted',
  },
};

export default ForethoughtConstants;
